import { IEnabledTest } from '../../models/teamTestConfig';

/**
 * Restituisce la label personalizzata per l'unità, oppure l'unità stessa come fallback.
 * Non usare mai label vuote: trim() + fallback garantisce sempre un valore visibile.
 */
export function resolveUnitLabel(
  unit: string,
  enabledTest?: IEnabledTest | null,
): string {
  return enabledTest?.unitLabels?.[unit]?.trim() || unit;
}

/**
 * Trova l'IEnabledTest corrispondente al testId dentro la lista config del team.
 * Ritorna undefined se non trovato o se la lista è assente.
 */
export function findEnabledTest(
  testId: string,
  enabledTests?: IEnabledTest[],
): IEnabledTest | undefined {
  return enabledTests?.find((e) => e.testId === testId);
}
